import Gettext, { type GettextInterface } from "@indeed/indeed-gettext";

import { loadCatalog } from "./Catalog";
import type { Locale } from "./Locale";

export type { GettextInterface, LocaleData } from "@indeed/indeed-gettext";

export { useI18n, I18nProvider, GettextContext } from "./I18nContext";
export { LocaleProvider, useLocale } from "./LocaleContext";
export {
  type Locale,
  deserializeTareLocale,
  deserializeLocaleString,
  deserializeLocaleStringOrNull,
  parseLocaleString,
  getCountryFromLocaleString,
  serializeLocaleToBCP47,
  DEFAULT_LOCALE,
} from "./Locale";
export { buildMockI18n } from "./Catalog";
export { makeSafeI18n } from "./makeSafeI18n";
export { useSafeI18n, type SafeGettextInterface, type SafeGettextOptions } from "./useSafeI18n";
export { type TranslatedString, asTranslatedString } from "./TranslatedString";
export { useBrandedI18n, type BrandedGettextInterface } from "./useBrandedI18n";

export function buildI18n(locale: Locale): GettextInterface {
  return Gettext(loadCatalog(locale));
}
